import api, { API } from "@/lib/api";

// Privacy-friendly first-party analytics. Only runs AFTER the user accepts cookies.
function hasConsent() {
  try {
    return localStorage.getItem("nj_cookies") === "1";
  } catch {
    return false;
  }
}

function getSid() {
  try {
    let s = localStorage.getItem("nj_analytics_sid");
    if (!s) {
      s = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      localStorage.setItem("nj_analytics_sid", s);
    }
    return s;
  } catch {
    return "anon";
  }
}

function newId() {
  return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

let current = null; // { eid, path, start }

function flushDuration() {
  if (!current) return;
  const payload = JSON.stringify({ eid: current.eid, duration_ms: Date.now() - current.start });
  current = null;
  try {
    const blob = new Blob([payload], { type: "application/json" });
    if (navigator.sendBeacon && navigator.sendBeacon(`${API}/analytics/duration`, blob)) return;
  } catch {
    /* fall through to fetch */
  }
  try {
    fetch(`${API}/analytics/duration`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    });
  } catch {
    /* ignore */
  }
}

export function trackPageview(path) {
  if (!hasConsent()) return;
  flushDuration();
  const eid = newId();
  current = { eid, path, start: Date.now() };
  api
    .post("/analytics/track", { sid: getSid(), eid, path, referrer: document.referrer || "" })
    .catch(() => {});
}

let bound = false;
export function bindAnalyticsLifecycle() {
  if (bound) return;
  bound = true;
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flushDuration();
  });
  window.addEventListener("pagehide", flushDuration);
}
